import { request } from '../client';
import { endpoints } from '../endpoints';

/**
 * Feasibility, calculated by the server from REAL panelists (country, age from date of birth, gender, region and
 * profiling answers) and the server's response / drop-out rate settings. One calculation serves both screens:
 * the target-group figure (planning strip) and one entry per quota row (Quotas table).
 *
 * Figures that cannot be calculated are `null` with `status: "notEnoughData"` and reasons: never a misleading 0.
 */

/**
 * POST /feasibility: works with the wizard's current, possibly unsaved, values. Everything in `input` is optional,
 * but countryId and incidenceRate are needed for a figure. Leave `quota` out for the planning strip only.
 * Invalid input (unknown ids, minAge > maxAge, bad gender, incidence rate outside 0-100) is a 400 with `errors`.
 * @param {object} input a FeasibilityInput (see features/feasibility/feasibilityInput.js)
 * @param {{ signal?: AbortSignal, timeoutMs?: number }} [opts]
 */
export const calculateFeasibility = (input, opts) =>
  request(endpoints.feasibility.calculate(), { method: 'POST', body: input, ...opts });

/** GET: the same calculation for a SAVED target group (empty body, so null, when it is not found). */
export const getTargetGroupFeasibility = (projectId, tgId, opts) =>
  request(endpoints.feasibility.saved(projectId, tgId), opts);
